// The internal chrome's surface + environment words. The environment is
// derived from the page's own hostname, not from identity config: one image
// is promoted across dev/staging/uat/prod (runtime-env.ts), and the last
// label before `.pemnet.ai` is the one signal guaranteed not to collide
// across environments the way an OIDC client id can (the "configurator"
// bare slug got reused for both dev and prod on 2026-10-01).

export const SURFACE_LABEL = "INTERNAL";

const STAGE_HOST = /\.([a-z0-9-]+)\.pemnet\.ai$/;

export function environmentLabel(
  hostname: string | undefined,
): string | undefined {
  const host = hostname?.trim().toLowerCase();
  if (!host) return undefined;
  const stage = host.match(STAGE_HOST)?.[1];
  if (stage) return stage.toUpperCase();
  // dev is the only stage still on its bare CloudFront domain pending the
  // manage_custom_domains cutover (infra/terraform/environments/dev).
  if (host.endsWith(".cloudfront.net")) return "DEV";
  if (host === "localhost" || host === "127.0.0.1") return "DEV";
  return undefined;
}

export function currentEnvironmentLabel(): string | undefined {
  return environmentLabel(window.location.hostname);
}
